var E = /* @__PURE__ */ ((t) => (t.DEFAULT = "default", t.PIPELINE = "pipeline", t.SAFETY = "safety", t))(E || {});
export {
  E as RocheUIHeadlineAppearance
};
